export default ({...props}) => {
  const {theme} = props
  const {palette, space} = theme
  return `
        color: ${palette.text.disabled};
        font-weight: 400;
        letter-spacing: 0.3rem;
        word-spacing: 0.2rem;
        text-transform: uppercase;
        box-shadow: 0px -4px 6px ${theme.boxShadow.hint};
        border-radius: 3px 3px 0 0;
        border-top: 1px solid ${theme.boxShadow.primary};
        border-bottom: none;
        padding: ${space(1)}px ${space(2)}px 0px ${space(2)}px;
        margin: ${space(5)}px ${space(0)}px ${space(3)}px ${space(0)}px;
        &:first-child{
          margin-top: 0px;
        }
    `
}
